import { MONTH } from '../constants';
import { CountryProfile } from '../types';

export const getDateObj = (
    dateString: string
): Date => {
    const datetimeValues: number[] = dateString.split('-').map(Number);
    const year = datetimeValues[0];
    const month = datetimeValues[1];
    const day = datetimeValues[2];

    if (
        (year && !isNaN(year))
        && (month && !isNaN(month))
        && (day && !isNaN(day))
    ) {
        return new Date(year, month - 1, day, 0, 0, 0, 0);
    }

    throw new Error(`Value cannot be parsed as Date: ${dateString}`)
};

export const getShortDate = (
    dateString: string
): string => {
    const dateObj = getDateObj(dateString);

    return (
        String(dateObj.getDate()).padStart(2, '0')
        + '/'
        + String(dateObj.getMonth() + 1).padStart(2, '0')
        + '/'
        + ((yearArray: string[]): string => (
            String(yearArray[2]) + String(yearArray[3])
        ))(String(dateObj.getFullYear()).split(''))
    );
};

export const getLargeDate = (datetime: number): string => {
    const dateObj = new Date(datetime);

    return (
        String(MONTH[dateObj.getMonth()])
        + ' '
        + String(dateObj.getDate())
        + ', '
        + String(dateObj.getFullYear())
    );
};

export const getCurrentDate = (): string => {
    const currentDate = new Date();

    return (
        currentDate.getFullYear()
        + '-'
        + (currentDate.getMonth() + 1)
        + '-'
        + currentDate.getDate()
    );
};

export const getLatestDates = (
    countryProfileList: CountryProfile[]
): {date: string, ipuDate: string} => {
    const result: ReturnType<typeof getLatestDates> = {
        date: '', ipuDate: ''
    };
    let selectedDateObj: Date;
    let selectedIpuDateObj: Date;

    countryProfileList.forEach(countryProfile => {
        const { date, ipuDate } = countryProfile;

        if (date) {
            const dateObj = getDateObj(date);
            const ipuDateObj = ipuDate ? getDateObj(ipuDate) : dateObj;

            if (!result.date || !result.ipuDate) {
                result.date = date;
                selectedDateObj = dateObj;

                result.ipuDate = ipuDate || date;
                selectedIpuDateObj = ipuDateObj;
            }
            else {
                if (dateObj > selectedDateObj) {
                    result.date = date;
                    selectedDateObj = dateObj;
                }

                if (ipuDateObj > selectedIpuDateObj) {
                    result.ipuDate = ipuDate || date;
                    selectedIpuDateObj = ipuDateObj;
                }
            }
        }
    });

    return result;
};

export const getLatestYear = (
    countryProfileList: CountryProfile[],
): number | null => {
    let latestYear: number | null = null;

    countryProfileList.forEach(countryProfile => {
        const year = new Date(countryProfile.datetime).getFullYear();

        if (Number.isFinite(year) && (latestYear === null || year > latestYear)) {
            latestYear = year;
        }
    });

    return latestYear;
};

export const getFullYearFromDatetime = (
    datetime: number
): number => {
    return new Date(datetime).getFullYear();
};
